import { render, staticRenderFns } from "./ReplaceCertificate.vue?vue&type=template&id=1d36f635&scoped=true"
import script from "./ReplaceCertificate.vue?vue&type=script&lang=js"
export * from "./ReplaceCertificate.vue?vue&type=script&lang=js"
import style0 from "./ReplaceCertificate.vue?vue&type=style&index=0&id=1d36f635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d36f635",
  null
  
)

export default component.exports